import groupModule from '../groupModule';
import { EnvironmentUrls } from 'Roblox';

function groupDetailsService(httpService, $filter, groupDetailsConstants) {
    "ngInject";

    function sendGroupShout(groupId, message) {
        var config = {
            url: $filter("formatString")(groupDetailsConstants.urls.updateGroupStatus, { id: groupId })
        };

        var data = {
            message: message
        };
        return httpService.httpPatch(config, data);
    };

    function profilePageUrl(userId) {
        return EnvironmentUrls.websiteUrl + "/users/" + userId + "/profile";
    };

    function abusePageUrl(type, id) {
        return $filter("formatString")(groupDetailsConstants.absoluteUrls.reportAbuse,
            { type: type, id: id, absUrl: encodeURIComponent(window.location.href) });
    };

    function advertiseGroupUrl(targetId) {
        return EnvironmentUrls.websiteUrl + "/user-ads/create?targetId=" + targetId + "&targetType=Group";
    };

    function configureGroupUrl(groupId) {
        return EnvironmentUrls.websiteUrl + "/groups/configure?id=" + groupId;
    };

    return {
        sendGroupShout: sendGroupShout,
        profilePageUrl: profilePageUrl,
        abusePageUrl: abusePageUrl,
        advertiseGroupUrl: advertiseGroupUrl,
        configureGroupUrl: configureGroupUrl
    };
}

groupModule.factory("groupDetailsService", groupDetailsService);

export default groupDetailsService;